
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"url(#icon-2f187b46020c3c7e__icon-ae2ae73748060308__a)","d":"M27 3.177v25.646c0 .65-.527 1.177-1.177 1.177H17V3.177C17 2.527 17.527 2 18.177 2h7.646C26.473 2 27 2.527 27 3.177Z"}}),_c('path',{attrs:{"fill":"#000","fill-opacity":".25","d":"M21.5 30V10.667c0-.92-.746-1.667-1.667-1.667H17v1h2.833c.369 0 .667.299.667.667V30h1Z","opacity":".5"}}),_c('path',{attrs:{"fill":"url(#icon-86783e5df203a002__icon-78d80608307eea7e__b)","d":"M21 10.167V30H11V10.17c0-.646.524-1.17 1.17-1.17h7.663C20.478 9 21 9.522 21 10.167Z"}}),_c('path',{attrs:{"fill":"url(#icon-9633c38098c76680__icon-454d81464787af1a__c)","d":"M5 17.17v11.66c0 .646.524 1.17 1.17 1.17H15V17.167c0-.645-.522-1.167-1.167-1.167H6.17A1.17 1.17 0 0 0 5 17.17Z"}}),_c('defs',[_c('linearGradient',{staticClass:"i-icon-2f187b46020c3c7e__icon-ae2ae73748060308__a",attrs:{"x1":"15.333","x2":"27.097","y1":"2","y2":"28.715","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#E6AD10"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#C87E0E"}})]),_c('linearGradient',{staticClass:"i-icon-86783e5df203a002__icon-78d80608307eea7e__b",attrs:{"x1":"10.999","x2":"20.929","y1":"9","y2":"29.633","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F6D751"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#E6AD10"}})]),_c('linearGradient',{staticClass:"i-icon-9633c38098c76680__icon-454d81464787af1a__c",attrs:{"x1":"4.999","x2":"10.444","y1":"16","y2":"29.825","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F9E589"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#F6D751"}})])])])
          )
        }
      }
    